import { config } from "../Environment";
import { useEffectOnce } from "../hooks/useEffectOnce";
import { useContext, useState } from "react";
import LoggerContext from "../context/LoggerProvider";
import useRetryFetch from "../hooks/useRetryFetch";
import "./Setup.css";

interface ActionButton {
  label: string;
  value: string;
}

interface ChecklistItem {
  status: string;
  message: string;
  actions?: [ActionButton];
}
interface Result {
  status: ChecklistItem[];
}
interface ActionResult {
  status: string;
  message: string;
  actions?: [ActionButton];
}

function Setup() {
  const { Logger } = useContext(LoggerContext);

  const [checklist, setChecklist] = useState<ChecklistItem[]>([]);
  const retryFetch = useRetryFetch();

  async function getSetup(): Promise<Result> {
    try {
      const result = await retryFetch(config.API_BASE + '/api/sysadmin/setup', {
        method: 'get',
        headers: {
          'Accept': 'application/json',
        },
      });
      const resultJson = result.json();
      Logger.debug(resultJson);
      return resultJson as Promise<Result>;
    } catch (err) {
      Logger.error('Failed to post status ' + err);
      return {status: [{ status: 'ERROR', message: 'Setup failed.' }]};
    }
  }

  async function postSetup(requestBody = {}): Promise<ActionResult> {
    try {
      console.log(`postSetup action ${JSON.stringify(requestBody)}`);
      const result = await retryFetch(config.API_BASE + '/api/sysadmin/setup', {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });
      const resultJson = result.json();
      Logger.debug(resultJson);
      return resultJson as Promise<ActionResult>;
    } catch (err) {
      Logger.error('Failed to post status ' + err);
      return { status: 'ERROR', message: 'Setup failed.' };
    }
  }

  async function getStatus() {
      const result = await getSetup();
      if (Array.isArray(result.status)) {
        setChecklist(result.status);
      }
  }

  useEffectOnce(() => {
    // call the setup API and render the results
    getStatus();
  }, []);

  function onClickActionButton(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    const button: HTMLButtonElement = event.currentTarget;
    const value = button.getAttribute('data-value');
    if (!value) {
      console.warn('Action button does not have action name');
      return;
    }
    (async function doSetupAction() {
      const result = await postSetup({ action: value });
      console.log(`doSetupAction result: ${JSON.stringify(result)}`);
      setChecklist([...checklist, result]);
    })();
  }

  function renderActionButtons(actions: [ActionButton] | undefined) {
    if (!Array.isArray(actions)) {
      return (<></>);
    }
    return actions.map((action, idx) => <button key={idx} className="action" onClick={onClickActionButton} data-value={action.value}>{action.label}</button>);
  }

  return <div className="container">
    <div className="content">
    <h1>Setup</h1>
    <ul>
      {checklist.map((item: ChecklistItem, idx) => (
        <li key={idx}>
          [{item.status}]
          {item.message}
          {renderActionButtons(item.actions)}
        </li>
      ))}
    </ul>
    </div>
  </div>;
}

export default Setup;
